import {
  Box,
  Button,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import exchange from "../../assets/arts/airdrop/exchange logo_green 8.png";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import "./RegisterAirDrop.css";
import {
  airdropRegister,
  baseCEXURL,
  wisbAirdropRegister,
  checkemail,
} from "../../services/api";
import CustomSnackbar from "../CustomSnackbar";
import errorLogo from "../../assets/popup/info 7 1.png";
import successLogo from "../../assets/popup/eagle wibs 2.png";
const WisExchangeRegister = () => {
  const isMobile = useMediaQuery("(max-width:768px)");

  const [emailAdd, setEmailAdd] = useState("");
  const [emailError, setEmailError] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [notificationContent, setNotificationContent] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const airdropAmount = 100000;
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const validateEmail = (mail) => {
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail);
    setEmailError(isValid ? "" : "Invalid email address");
    return isValid;
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification({ ...notification, open: false });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const res = await checkemail(emailAdd);
      if (res.success) {
        // setNotification({
        //   open: true,
        //   message: "User email is not registered",
        //   severity: "error",
        // });
        setNotificationContent({
          open: true,
          message: "User email is not registered",
          severity: "error",
        });
      } else {
        if (res.userType === "Indexx Exchange") {
          let register = await wisbAirdropRegister(
            emailAdd,
            res.userType,
            undefined,
            undefined,
            airdropAmount,
            "WIBS",
            "WhoIsBitcoinSatoshiAirdrop27May2024"
          );
          // setNotification({
          //   open: true,
          //   message: register.data.message + " for airdrop",
          //   severity: "success",
          // });
          setNotificationContent({
            message: register.data.message,
            severity: "success",
          });

          setOpenPopup(true);
        } else if (res.data === "Email already in use") {
          // setNotification({
          //   open: true,
          //   message: `You have already registered once. Please wait for the airdrop launch date.`,
          //   severity: "error",
          // });
          setNotificationContent({
            message: `Only Indexx Exchange users are allowed for this airdrop.`,
            severity: "error",
          });
          setOpenPopup(true);
        } else {
          // setNotification({
          //   open: true,
          //   message: res.data,
          //   severity: "error",
          // });
          setNotificationContent({
            message: res.data,
            severity: "error",
          });
          setOpenPopup(true);
        }
      }
    } catch (error) {
      console.error("Error in submitting:", error);
      // setNotification({
      //   open: true,
      //   message: "An error occurred during submission. Please try again later.",
      //   severity: "error",
      // });
      setNotificationContent({
        message: "An error occurred during submission. Please try again later.",
        severity: "error",
      });
      setOpenPopup(true);
    } finally {
      setIsLoading(false); // End loading
    }
  };
  const closePopupHandler = () => {};

  const buttonArr = [
    {
      text: "Contact Us",
      close: false,
      show: "both",
      href: "https://whoisbitcoinsatoshi.wtf",
      style: {
        background: "#11BE6A",
        hover: {
          background: "#0EA55A",
        },
      },
    },
    {
      text: "Retry",
      close: true,
      show: "error",
      href: "#",
      style: {
        background: "#11BE6A",
        hover: {
          background: "#0EA55A",
        },
      },
    },
    {
      text: "Buy Memecoins",
      close: false,
      show: "success",
      href: "https://whoisbitcoinsatoshi.wtf/coin",
      style: {
        background: "#11BE6A",
        hover: {
          background: "#0EA55A",
        },
      },
    },
  ];
  return (
    <div style={{ paddingTop: "180px" }}>
      {/* <Snackbar
        open={notification.open}
        autoHideDuration={1000000}
        onClose={handleClose}
        sx={{
          top: "50% !important",
          left: "50% !important",
          transform: "translate(-50%, -50%) !important",
        }}
      >
        <div>
          <MuiAlert
            onClose={handleClose}
            severity={notification.severity}
            sx={{
              width: "100%",
              border: "2px solid #0ea55a",
              backgroundColor: "white",
            }}
          >
            {notification.message}
          </MuiAlert>
        </div>
      </Snackbar> */}
      {notificationContent && (
        <CustomSnackbar
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          icon={
            notificationContent?.severity === "error" ? errorLogo : successLogo
          }
          heading={
            notificationContent?.severity === "error"
              ? "Oops"
              : "Congratulations"
          }
          paragraph={notificationContent?.message}
          buttonArr={
            notificationContent?.severity === "error"
              ? buttonArr.filter(
                  (el) => el.show === "error" || el.show === "both"
                )
              : buttonArr.filter(
                  (el) => el.show === "success" || el.show === "both"
                )
          }
        />
      )}

      <div
        className="d-flex flex-column justify-content-center align-items-center font_40x text-center fw-bold mb-5"
        style={{ maxWidth: "484px", margin: "auto" }}
      >
        <img src={exchange} alt="hive" style={{ width: "fit-content" }} />
        <div className="mt-2 font_46x">
          Airdrop Registration
          <div className={isMobile ? "font_50x fw-bold" : ""}>
            Indexx Exchange
          </div>
        </div>
      </div>
      <div
        className="d-flex flex-column justify-content-center align-items-center mt-2 pb-2"
        style={{ maxWidth: "440px", margin: "auto" }}
      >
        <Box
          width={"100%"}
          className="d-flex flex-column align-items-center"
          mb={isMobile ? 0 : 5}
        >
          <Typography
            variant="text"
            fontSize={"15px"}
            fontWeight={500}
            textAlign={"left"}
            width={"100%"}
          >
            Email Address:
          </Typography>

          <TextField
            label=""
            placeholder="Enter your Indexx Exchange Email Address"
            variant="outlined"
            sx={{
              width: "100%",
              border: "none", // Add this line to remove the border
            }}
            size="small"
            value={emailAdd}
            error={emailError !== ""}
            helperText={emailError}
            onChange={(e) => {
              setEmailAdd(e.target.value);
              validateEmail(e.target.value);
            }}
          />

          <Button
            variant="contained"
            disableTouchRipple
            onClick={handleSubmit}
            disabled={isLoading}
            sx={{
              backgroundColor: "#11BE6A",
              borderRadius: "2px",

              px: 10,
              py: 1,
              textTransform: "none",
              fontSize: "13px",
              fontWeight: 700,
              boxShadow: "none",
              mt: 2,
              mb: 2,
              height: `${isMobile ? "55px" : "40px"}`,
              "&:hover": {
                backgroundColor: "#0EA55A",
                boxShadow: "none",
              },
            }}
          >
            {isLoading ? "Loading..." : "Submit"}
          </Button>
        </Box>

        <div
          className="font_11x text-center"
          style={{ width: `${isMobile ? "100%" : "316px"}` }}
        >
          If you don't have an Exchange account, please
          {!isMobile ? <br /> : <>&nbsp;</>}
          <a
            href={`${baseCEXURL}/indexx-exchange/buy-sell/get-started`}
            className="exch-link"
          >
            Signup here
          </a>
        </div>
      </div>
    </div>
  );
};

export default WisExchangeRegister;
